import { render, staticRenderFns } from "./PageItemDropdown.vue?vue&type=template&id=e15e5b10&scoped=true&"
import script from "./PageItemDropdown.vue?vue&type=script&lang=js&"
export * from "./PageItemDropdown.vue?vue&type=script&lang=js&"
import style0 from "./PageItemDropdown.vue?vue&type=style&index=0&id=e15e5b10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e15e5b10",
  null
  
)

export default component.exports